import { useSocialLinks } from 'hooks/useSocialLinks';
import './FooterApp.scss';

export function FooterApp() {
    const { socialLinks } = useSocialLinks();
    if (socialLinks.length === 0) return null;

    return (
        <footer className="footer">
            <ul className="footer__list">
                {
                    socialLinks.map(socialLink => {
                        return (
                            <li
                                key={socialLink.id}
                                className="footer__item"
                            >
                                <a href={socialLink.href}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    aria-label={socialLink.ariaLabel}
                                    title={socialLink.tooltip}
                                    className="footer__link"
                                >
                                    <i className={socialLink.iconFullName}></i>
                                    <span className="footer__name">
                                        {socialLink.name}
                                    </span>
                                </a>
                            </li>
                        )
                    })
                }
            </ul>
        </footer>
    )
}